import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import './Home.css';
import Navbar from './Navbar';
import Graficos from './Graficos';
import Lista from './Lista';
import Jogadores from './Jogadores';
import { Row } from 'react-materialize';
import MedidasService from '../services/MedidasService';
import AuthService from '../services/AuthService';

class Home extends Component {


	state = {
		usuarios: [],
		order: 'Obesidade',
		indicador: 'IMC'
	}

	constructor(){
		super();
		this.medidas = new MedidasService();
		this.Auth = new AuthService()
	}

	getUser(id){
		return this.state.usuarios.filter(user =>  user.id == id)[0];
	}

	componentDidMount(){
		this.medidas.getMedidas(this.Auth.getEmpresa()).then(
			(response) => {
				var userResponse = response.data;
				if(userResponse){
					this.setState({usuarios: userResponse});
				}
			}
		);
	}

	render() {
			return (
					<div>
						<Navbar />
						<Row className="conteudo">
							<div>
								<Graficos usuarios={this.state.usuarios} changeIndicador={(e) => this.setState({indicador: e})} arrange={(e) => this.setState({order: e})}/>
								<Route exact path="/home" render={() => <Lista usuarios={this.state.usuarios} indicador={this.state.indicador} order={this.state.order} /> }/>
								<Route exact path="/home/jogador/:id" render={(routeProps) => <Jogadores usuario={this.getUser(routeProps.match.params.id)}/> }/>
							</div>
						</Row>						
					</div>
			);

	}
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js